import UnreadChatsService from '../../services/inbox/UnreadChatsService';
import { canViewConversationByAssignment } from '../../services/inbox/conversationFilterEvaluator';
import { noteMsInboxCountersMutated } from '../../services/inbox/msInboxCountersClient';
import {
  applyCounterDelta,
  applyMsCounterEvent,
  deriveMonolithCounts,
  resolveSidebarCounterPlatform,
  shouldUseMonolithCounterSource
} from '../../services/inbox/dualCountersMergeService';

export const ADD_UNREAD_CHAT = 'ADD_UNREAD_CHAT';
export const REMOVE_UNREAD_CHAT = 'REMOVE_UNREAD_CHAT';
export const SET_PLATFORM_COUNTS = 'SET_PLATFORM_COUNTS';
export const UPDATE_PLATFORM_COUNT = 'UPDATE_PLATFORM_COUNT';

function countForPlatform(data, platformKey) {
  const arr = data?.[platformKey];
  return Array.isArray(arr) ? arr.length : 0;
}

function syncMonolithPlatformCount(platformCounts, data, platformKey, delta) {
  const base = platformCounts || deriveMonolithCounts(data);
  return applyCounterDelta(base, platformKey, delta);
}

function msPlatformsFromState(getState) {
  return getState().retailerUsersReducer?.retailer_info?.inbox_microservice_platforms;
}

function publishLivePlatformCount(dispatch, counts) {
  noteMsInboxCountersMutated();
  dispatch({
    type: UPDATE_PLATFORM_COUNT,
    payload: counts
  });
}

export function setPlatformCounts(platformCounts) {
  return {
    type: SET_PLATFORM_COUNTS,
    payload: platformCounts
  };
}

export function updatePlatformCountFromMsEvent(event) {
  return (dispatch, getState) => {
    const { platformCounts, data } = getState().unreadChatsReducer;
    const base = platformCounts || deriveMonolithCounts(data);
    const { counts, applied } = applyMsCounterEvent(base, event, msPlatformsFromState(getState));

    if (applied) {
      publishLivePlatformCount(dispatch, counts);
    }

    return applied;
  };
}

export function addUnreadChat({
  platform,
  chat,
  assignedAgentId = null,
  trustRoomAuthorization = false
}) {
  return (dispatch, getState) => {
    const currentRetailerUser = getState().mainReducer?.currentRetailerUser;
    const currentUserId = currentRetailerUser?.id;
    const shouldSkipAssignmentCheck = trustRoomAuthorization || assignedAgentId == null;

    if (!shouldSkipAssignmentCheck
      && !canViewConversationByAssignment(currentRetailerUser, currentUserId, assignedAgentId)) {
      return;
    }

    const storagePlatform = resolveSidebarCounterPlatform(platform);
    if (!storagePlatform) return;

    const { data, platformCounts } = getState().unreadChatsReducer;
    const prevCount = countForPlatform(data, storagePlatform);
    const newData = UnreadChatsService.addChat(data || {}, storagePlatform, chat);
    const nextCount = countForPlatform(newData, storagePlatform);
    const delta = nextCount - prevCount;

    dispatch({
      type: ADD_UNREAD_CHAT,
      payload: { data: newData, platform: storagePlatform, chat }
    });

    if (delta !== 0 && shouldUseMonolithCounterSource(storagePlatform, msPlatformsFromState(getState))) {
      publishLivePlatformCount(
        dispatch,
        syncMonolithPlatformCount(platformCounts, newData, storagePlatform, delta)
      );
    }
  };
}

export function removeUnreadChat({ platform, id }) {
  return (dispatch, getState) => {
    const storagePlatform = resolveSidebarCounterPlatform(platform);
    if (!storagePlatform) return;

    const { data, platformCounts } = getState().unreadChatsReducer;
    const prevCount = countForPlatform(data, storagePlatform);
    const newData = UnreadChatsService.removeChat(data || {}, storagePlatform, id);
    const nextCount = countForPlatform(newData, storagePlatform);
    const delta = nextCount - prevCount;

    dispatch({
      type: REMOVE_UNREAD_CHAT,
      payload: { data: newData, platform: storagePlatform, id }
    });

    if (delta !== 0 && shouldUseMonolithCounterSource(storagePlatform, msPlatformsFromState(getState))) {
      publishLivePlatformCount(
        dispatch,
        syncMonolithPlatformCount(platformCounts, newData, storagePlatform, delta)
      );
    }
  };
}
